import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  getOpenDemoModel() {
    throw new Error('Method not implemented.');
  }
  openSignInModal = new BehaviorSubject<boolean>(false);
  openSignUpModal = new BehaviorSubject<boolean>(false);
  menuIndex = new BehaviorSubject<number>(0);
  searchCondition = new Subject<number>();
  reinitialize = new BehaviorSubject<boolean>(false);
  totalRecordsCount = new BehaviorSubject<number>(0);
  searchQuery = new BehaviorSubject<string>("");
  searchFilters = new BehaviorSubject<any>({});
  isComeFromFilter = new BehaviorSubject<boolean>(false);
  backToResult = new BehaviorSubject<boolean>(false);

  constructor() { }

  sendOpenSignInModal(data: any) {
    this.openSignInModal.next(data);
  }

  getOpenSignInModal() {
    return this.openSignInModal.asObservable();
  }
  sendOpenSignUpModal(data: any) {
    this.openSignUpModal.next(data);
  }

  getOpenSignUpModal() {
    return this.openSignUpModal.asObservable();
  }

  sendMenuIndex(data: any) {
    this.menuIndex.next(data);
  }

  getMenuIndex() {
    return this.menuIndex.asObservable();
  }

  sendSearchCondition(data: any) {
    this.searchCondition.next(data);
  }

  getSearchCondition() {
    return this.searchCondition.asObservable();
  }
}
